/**
 * Every path that is used in the application must be added here. This way, if a path changes, it will be changed in one place only.
 */
export const PATHS = {
  path: '',
  home: {
    root: '/home',
    view: (slug_id: number | string) => `/client/${slug_id}`,
  },
  login: {
    root: '/auth/login',
    view: (slug_id: number|string) => `/client/${slug_id}/auth/login`
  },
  profile: {
    root: '/profile/me',
    view: (slug_id: number|string) => `/client/${slug_id}/profile/me`,
    voucher: (slug_id: number|string) => `/client/${slug_id}/profile/vouchers`,
    personalConfig: (slug_id: number|string) => `/client/${slug_id}/profile/personal-configuration`,
  },
  verify: {
    root: '/auth/verify',
    view: (slug_id: number|string) => `/client/${slug_id}/auth/verify`
  },
  delivery: {
    root: '/delivery',
    enterAddress: {
      root: '/delivery/enter-address',
      view: (slug_id: number | string) => `/client/${slug_id}/delivery/enter-address`,
    },
    menu: {
      root: '/delivery/menu',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}`
    },
    article: {
      root: '/delivery/article',
      view: (slug_id: number | string,
        shop_id: number | string,
        article_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/article/${article_id}`
    },
    cart: {
      root: '/delivery/cart',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}/cart`
    },
    login: {
      root: '/delivery/login',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}/login`
    },
    code: {
      root: '/delivery/code',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}/code`
    },
    detailOrder: {
      root: '/delivery/detail-order',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string,
        order_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}/detail-order/${order_id}`,
      payment: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string,
        order_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}/detail-order/${order_id}/payment`,
      paymentBizum: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string,
        order_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}/detail-order/${order_id}/paymentBizum`
    },
    success: {
      root: '/delivery/success',
      view: (slug_id: number | string,
        order_id: number | string) => `/client/${slug_id}/delivery/${order_id}/success`
    },
    error: {
      root: '/delivery/error',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/delivery/${shop_id}/menu/${menu_id}/error`
    },
    tracking: {
      root: '/delivery/tracking-order',
      view: (slug_id: number | string, order_id: number | string) => `/client/${slug_id}/delivery/tracking-order/${order_id}`
    }
  },
  showMenu: {
    root: '/show-menu',
    selector: {
      root: '/show-menu/shop-selector',
      view: (
        slug_id: number | string) => `/client/${slug_id}/show-menu/shop-selector`
    },
    menu: {
      root: '/show-menu/menu',
      view: (slug_id: number | string,  
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/show-menu/${shop_id}/menu/${menu_id}`
    }
  },
  dineIn: {
    root: '/dinein',    
    selector: {
      root: '/dinein/shop-selector',
      view: (
        slug_id: number | string,
        shop_id: number | string,
        table_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/shop-selector`
    },
    menu: {
      root: '/dinein/menu',
      view: (slug_id: number | string,
        shop_id: number | string,
        table_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/menu/${menu_id}`
    },
    article: {
      root: '/dinein/article',
      view: (slug_id: number | string,
        shop_id: number | string,
        table_id: number | string,
        article_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/article/${article_id}`
    },
    cart: {
      root: '/dinein/cart',
      view: (slug_id: number | string,
        shop_id: number | string,
        table_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/menu/${menu_id}/cart`
    },
    login: {
      root: '/dinein/login',
      view: (slug_id: number | string,
        shop_id: number | string,
        table_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/menu/${menu_id}/login`
    },
    code: {
      root: '/dinein/code',
      view: (slug_id: number | string,
        shop_id: number | string,
        table_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/menu/${menu_id}/code`
    },
    detailOrder: {
      root: '/dinein/detail-order',
      view: (slug_id: number | string,
        shop_id: number | string,
        table_id: number | string,
        menu_id: number | string,        
        order_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/menu/${menu_id}/detail-order/${order_id}`,
      payment: (slug_id: number | string,
          shop_id: number | string,
          table_id: number | string,
          menu_id: number | string,          
          order_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/menu/${menu_id}/detail-order/${order_id}/payment`,          
      paymentBizum: (slug_id: number | string,
          shop_id: number | string,
          table_id: number | string,
          menu_id: number | string,          
          order_id?: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}//menu/${menu_id}/detail-order/${order_id}/paymentBizum`
    },
    success: {
      root: '/dinein/success',
      view: (slug_id: string,
        order_id: number | string) => `/client/${slug_id}/dinein/${order_id}/success`
    },
    error: {
      root: '/dinein/error',
      view: (slug_id: number | string,
        shop_id: number | string,
        table_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/dinein/${shop_id}/${table_id}/menu/${menu_id}/error`
    },
    tracking: {
      root: '/dinein/tracking-order',
      view: (slug_id: number | string, order_id: number | string) => `/client/${slug_id}/dinein/tracking-order/${order_id}`
    }
  },
  takeAway: {
    root: '/takeaway',
    selector: {
      root: '/takeaway/shop-selector',
      view: (
        slug_id: number | string) => `/client/${slug_id}/takeaway/shop-selector`
    },
    menu: {
      root: '/takeaway/menu',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}`
    },
    article: {
      root: '/takeaway/article',
      view: (slug_id: number | string,
        shop_id: number | string,
        article_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/article/${article_id}`
    },
    cart: {
      root: '/takeaway/cart',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}/cart`
    },
    login: {
      root: '/takeaway/login',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}/login`
    },
    code: {
      root: '/takeaway/code',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}/code`
    },
    detailOrder: {
      root: '/takeaway/detail-order',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string,        
        order_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}/detail-order/${order_id}`,
      payment: (slug_id: number | string,
          shop_id: number | string,
          menu_id: number | string,
          order_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}/detail-order/${order_id}/payment`,
      paymentBizum: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string,        
        order_id?: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}/detail-order/${order_id}/paymentBizum`
    },
    success: {
      root: '/takeaway/success',
      view: (slug_id: string,
        order_id: number | string) => `/client/${slug_id}/takeaway/${order_id}/success`
    },
    error: {
      root: '/takeaway/error',
      view: (slug_id: number | string,
        shop_id: number | string,
        menu_id: number | string) => `/client/${slug_id}/takeaway/${shop_id}/menu/${menu_id}/error`
    },
    tracking: {
      root: '/takeaway/tracking-order',
      view: (slug_id: number | string, order_id: number | string) => `/client/${slug_id}/takeaway/tracking-order/${order_id}`
    }
  },
  preorder: {
    root: '/preorder',
    dateTimeSelector: {
      root: '/preorder/date-time-selector',
      view: (slug_id: number | string) => `/client/${slug_id}/preorder/date-time-selector`
    }
  },
  guest: {
    root: '/guest',
    paymentLink: {
      root: '/guest/payment-link',
      view: (slug_id: number | string, order_id: number | string) => `/client/${slug_id}/guest/payment-link/${order_id}`
    },
    sucessPaymentLink: {
      root: '/guest/success-payment-link',
      view: (slug_id: number | string, order_id: number | string) => `/client/${slug_id}/guest/success-payment-link/${order_id}`
    },
    warningPaymentLink: {
      root: '/guest/warning-payment-link',
      view: (slug_id: number | string, order_id: number | string) => `/client/${slug_id}/guest/warning-payment-link/${order_id}`
    },
  },
  dashboard: {
    root: '/dashboard',
    home: '/dashboard/home',
  },
} as const;

/**
 * Every path that a role can access must be added here. Otherwise, the user will be redirected to the Not allowed page.
 */
export const PATHS_PER_ROLE = [
  {
    role: 'admin',
    paths: [
    ],
  },
];
